import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Minute } from '../../../class/minute';
import { MinuteService } from '../../../service/minute/minute.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';

@Component({
  selector: 'app-new-minute',
  templateUrl: './new-minute.component.html',
  styleUrls: ['./new-minute.component.scss']
})
export class NewMinuteComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Minute;
    @Input() new: Minute;
    public promiseForm: Promise<any>;
    public form: FormGroup;
    public user_id: AbstractControl;
    public description: AbstractControl;
    public type: AbstractControl;
    public status: AbstractControl;
    public created_at: AbstractControl;

    public typeOptions: SelectItem[];

    constructor(
        fb: FormBuilder,
        public openingStationService: MinuteService,
        public translate: TranslateService,
        private notificationsService: NotificationsService,
        private ngZone: NgZone) {

        this.typeOptions = [
            {label: 'choose', value: ''},
            {label: 'Novedad', value: 'Novedad'},
            {label: 'Tarea', value: 'Tarea'},
            {label: 'Trámite', value: 'Trámite'},
            {label: 'Nota', value: 'Nota'},
        ];
    
        this.form = fb.group({
            'user_id': [{value: '', disabled: true}],
            'description': ['', Validators.compose([Validators.required, Validators.minLength(2)])],
            'type': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'status': [''],
            'created_at': [{value: '', disabled: true}],
        });

        this.user_id = this.form.controls['user_id'];
        this.description = this.form.controls['description'];
        this.type = this.form.controls['type'];
        this.status = this.form.controls['status'];
        this.created_at = this.form.controls['created_at'];
    }

    ngOnInit() {
        if (this.edit) {
            this.user_id.setValue(this.edit.user.employee.name);
            this.description.setValue(this.edit.description);
            this.type.setValue(this.edit.type);
            this.status.setValue(this.edit.status);
            this.created_at.setValue(this.edit.created_at);
        }
    }

    public cancelMinute () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public newMinute(values: Minute) {
        if (values.type === 'Trámite' && values.status === '') {
            values.status = 'Pendiente';
        }

        const param = {
            'description': values.description,
            'type': values.type,
            'status': values.status,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.openingStationService.updateMinute(this.edit.id, param)
                :
                this.openingStationService.newMinute(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public checkOtherValidation (values) {
        let check = false;
        if (values) {
            if (values.station_id) {
                if (values.station_id.id) {
                    check = true;
                } else {
                    return false;
                }
            }
        }
        return check;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/minutes/new-minute/new-minute.component.ts